// Route: /study-plan/calendar — LEGACY redirect → /courses/calendar.
//
// «Учебный календарь» переехал под курсы (обучающая система, docs/plans/
// LEARNING-SYSTEM-UI.md §8: пункт «Календарь» первичной навигации ведёт на
// /courses/calendar). Контракт search тот же (?plan/?date/?view) — прокидываем.
//
// Generic /calendar (routes/calendar.tsx) — НЕ трогаем (другой контракт, D16).

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	plan: z.array(z.string()).optional(),
	date: z
		.string()
		.regex(/^\d{4}-\d{2}$/)
		.optional(),
	view: z.enum(["month", "agenda"]).optional(),
});

export const Route = createFileRoute("/study-plan/calendar")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		// Схемы совпадают ключ в ключ (`plan` / `date` / `view`), но переклад
		// всё равно явный: каст скрыл бы расхождение, если завтра правку внесут
		// только в одну из сторон.
		throw redirect({
			to: "/courses/calendar",
			search: {
				...(search.plan ? { plan: search.plan } : {}),
				...(search.date ? { date: search.date } : {}),
				...(search.view ? { view: search.view } : {}),
			},
			replace: true,
		});
	},
});
